import { ProductLiteResponseModel } from '../../../../modules/products-catalog/models/response-models/product-response.model';
import { TrackInventoryOption } from '../../../enums/enum';

// Paged response wrapper
export class TransferDispatchBoxAllocationPagedResponse {
  totalCount: number = 0;
  pageNumber: number = 0;
  pageSize: number = 0;
  items: TransferDispatchBoxAllocationResponse[] = [];
}

// Base model (shared fields)
export abstract class TransferDispatchBoxAllocationModel {
  id: number = 0;
  transferDispatchBoxId: number = 0;
  dispatchItemId: number = 0;
  productId: number = 0;
  quantityPicked: number = 0;
  productSerialId:number = 0;
  trackInventoryOption: TrackInventoryOption = TrackInventoryOption.Unknown;
}

// Response DTO (includes product details)
export class TransferDispatchBoxAllocationResponse extends TransferDispatchBoxAllocationModel {
  product: ProductLiteResponseModel = new ProductLiteResponseModel();
}

// Command DTO (used for create/update)
export class TransferDispatchBoxAllocationCommand extends TransferDispatchBoxAllocationModel {}

export class ProgressBarData {
  percent: number = 0; // 0..100
  value: number = 0; // filled amount (kg for weight, m^3 for volume)
  max: number = 0; // capacity (kg or m^3)
  label: string = ''; // display label, e.g. "6.00 / 30.00 kg"
}

export class RawBoxMetrics {
  weightKg: number = 0;
  capacityKg: number = 0;
  volumeM3: number = 0;
  capacityM3: number = 0;
}
export class BoxMetrics {
  weight: ProgressBarData = new ProgressBarData();
  weightLb?: ProgressBarData = new ProgressBarData();
  volume: ProgressBarData = new ProgressBarData();
  raw: RawBoxMetrics = new RawBoxMetrics();
}

export class DispatchBoxMetricsResult {
  current: BoxMetrics = new BoxMetrics(); // allocations with id > 0
  preview: BoxMetrics = new BoxMetrics(); // includes id === 0 allocations
}
export class DispatchBoxSummary {
  id: number = 0;
  shipmentBoxName: string = '';
  boxName: string = '';
  items: number = 0; // number of allocations
  units: number = 0; // total picked quantity
  weight: number = 0;
  weightCapacity: number = 0;
  products: DispatchBoxProduct[] = [];
}
export class DispatchBoxProduct {
  productId: number = 0;
  name: string = '';
  sku: string = '';
  quantityPicked: number = 0;
  weight: number = 0;
  totalWeight: number = 0;
}
